import axios from "axios";
import { IPerson } from "redmond";

import { config } from "../../config";
import { passengersApiPrefix } from "../../paths";

const END_POINT: string = `${passengersApiPrefix}/list_by_business`;

export interface PassengersForBusiness {
  businessId: string;
  passengers: IPerson[];
  error?: string;
}

export interface IFetchPassengersByBusinessResponse {
  value: {
    businesses: PassengersForBusiness[];
  };
}

export const fetchPassengersByBusiness = async (
  businessIds: string[]
): Promise<PassengersForBusiness[]> => {
  const res = await axios.put(
    END_POINT,
    { businessIds },
    { baseURL: config.baseURL }
  );
  const responseBody: IFetchPassengersByBusinessResponse = res.data;
  return responseBody.value.businesses;
};
